import { render, staticRenderFns } from "./SubdomainField.vue?vue&type=template&id=a2815be6&"
import script from "./SubdomainField.vue?vue&type=script&lang=js&"
export * from "./SubdomainField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports